<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <v-checkbox v-model="fields.cardTitle.show" class="mb-2 mt-0" label="Show title block" hide-details />
          <label class="label-input mb-2 d-block">Title content</label>
          <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
        </div>

        <div class="mb-4">
          <label class="label-input">Left card (stat list)</label>
          <div class="group-item">
            <v-text-field v-model.number="fields.cardLeft.order" type="number" label="Order" hide-details />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Right card</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model.number="fields.cardRight.order" type="number" label="Order" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.cardRight.bgColor"
                    @change="e => (fields.cardRight.bgColor = e.target.value)"
                  />
                  <v-text-field v-model="fields.cardRight.bgColor" label="Background color" hide-details />
                </div>
              </v-col>
            </v-row>
            <label class="label-input mb-2 mt-3 d-block">Content</label>
            <ckeditor :editor="editor" v-model="fields.cardRight.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Stat items ({{ fields.listItemStat.length }})</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add stat</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion class="mt-2">
            <v-expansion-panel v-for="(item, index) in fields.listItemStat" :key="`feetscare-stat-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Stat {{ index + 1 }} — {{ item.value }}</span>
                  <v-btn icon @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="item.value" label="Value (e.g. 93%)" hide-details />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="item.color"
                        @change="e => (item.color = e.target.value)"
                      />
                      <v-text-field v-model="item.color" label="Icon color" hide-details />
                    </div>
                  </v-col>
                </v-row>

                <div class="mt-3">
                  <div class="d-flex align-center mb-2" style="gap: 10px">
                    <label class="label-input mb-0">Icon</label>
                    <v-checkbox v-model="item.showIcon" label="Show icon" hide-details class="mt-0 pt-0" />
                  </div>
                  <template v-if="item.showIcon">
                    <v-radio-group v-model="item.useSvg" row hide-details class="mt-0">
                      <v-radio label="Icon Image" :value="false"></v-radio>
                      <v-radio label="Icon SVG" :value="true"></v-radio>
                    </v-radio-group>
                    <div class="mt-2">
                      <UploadImage
                        v-if="!item.useSvg"
                        @callback="obj => handleUploadIconImage(obj, index)"
                        :image="{ imageSrc: item.icon || '' }"
                        :height="`100`"
                        :typeUpload="'image'"
                        @callbackDelete="() => handleRemoveIconImage(index)"
                      />
                      <UploadSVG
                        v-else
                        :svg="{ svgContent: item.iconSvg }"
                        :height="`100`"
                        :heightPreview="`300`"
                        @callback="obj => handleUploadIconSvg(obj, index)"
                        @callbackDelete="() => handleRemoveIconSvg(index)"
                      />
                    </div>
                  </template>
                </div>

                <label class="label-input mb-2 mt-3 d-block">Description</label>
                <ckeditor :editor="editor" v-model="item.description" :config="editorConfig" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import UploadSVG from '@/components/form/uploadFile/UploadSVG.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import { updateHtmlFromData } from '../common/html/update.js';

export default {
  name: 'feetscare-stat-section-editor',
  components: {
    UploadImage,
    UploadSVG,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Feetscare Stat',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#ffffff',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content: '<h2 style="text-align: center">Designed for everyday comfort</h2>',
        },
        cardLeft: {
          order: 1,
        },
        cardRight: {
          order: 2,
          bgColor: '#ffffff',
          content: '<h2>Trusted By Everyday Users</h2>',
        },
        listItemStat: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        cardLeft: { ...this.fields.cardLeft, ...(extract.cardLeft || {}) },
        cardRight: { ...this.fields.cardRight, ...(extract.cardRight || {}) },
        listItemStat: Array.isArray(extract.listItemStat) ? extract.listItemStat : this.fields.listItemStat,
      };
    },
    handleAddItem() {
      this.fields.listItemStat.push({
        value: '90%',
        color: '#417505',
        showIcon: true,
        useSvg: false,
        icon: '',
        iconSvg: '',
        description: '<p>Description text</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItemStat.splice(index, 1);
    },
    handleUploadIconImage(obj, index) {
      if (!this.fields.listItemStat[index]) return;
      this.$set(this.fields.listItemStat[index], 'icon', obj.imageSrc || '');
    },
    handleRemoveIconImage(index) {
      if (!this.fields.listItemStat[index]) return;
      this.$set(this.fields.listItemStat[index], 'icon', '');
    },
    handleUploadIconSvg(obj, index) {
      if (!this.fields.listItemStat[index]) return;
      this.$set(this.fields.listItemStat[index], 'iconSvg', obj.svgContent || '');
    },
    handleRemoveIconSvg(index) {
      if (!this.fields.listItemStat[index]) return;
      this.$set(this.fields.listItemStat[index], 'iconSvg', '');
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFeetscareStat(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
